
<template>
    <section style="padding:20 0;">
        <el-row type="flex" style="margin-bottom:0;">
            <el-input v-model="key_word" placeholder="搜索关键字" clearable style="width:384px;"></el-input>
            <el-button type="primary" style="margin-left:20" @click="toSearch()">搜索</el-button>
        </el-row>

        <el-row>
            <el-col :span="col_span" style="padding-left:0;">
                <el-radio-group v-model="activeName" @change="handleClick" style="margin-bottom:20">
                    <el-radio label="first">全部群</el-radio>
                    <el-radio label="second">敏感词</el-radio>
                </el-radio-group>
                <div  v-if="activeName=='second'">
                    <el-input placeholder="搜索敏感词" clearable v-model="filter_word" @input="filterBy('name',filter_word)" size="small" style="margin-bottom:10;"></el-input>
                    <el-table v-loading="loading" :highlight-current=false :check-on-click-node=true :data="list" :border="false" 
                        @row-click="searByWord" :max-height="(innerHeight-300)" highlight-current-row> 
                        <el-table-column label="敏感词" prop="name"></el-table-column>
                        <el-table-column label="命中次数" prop="count" align="center"></el-table-column>
                        <el-table-column width="50">
                            <template slot-scope="scope1">
                                <i class="el-icon-arrow-right" style="color:#AAAAAA;"></i>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

                <div v-else>
                    <el-main v-loading="loading" :style="'height:'+(innerHeight-220)+'px'" style="padding:0">
                        <el-input placeholder="搜索群" clearable v-model="group_name" @input="getList" size="small" style="margin-bottom:10;"></el-input>
                        <el-tree :check-on-click-node=true :data="group_tree" node-key="id" ref="tree" 
                            :filter-node-method="filterNode" @node-click="handleNodeClick" :props="{ label: 'name' }" accordion >
                            <span slot-scope="{node,data}" class="custom-tree-node">
                                <span style="font-size:14px;color:#333333;">
                                    <svg data-v-7eb2bc79 aria-hidden="true" class="icon" v-if="node.childNodes.length!=0"> 
                                        <use data-v-7eb2bc79 :xlink:href="node.expanded?'#icon-wenjianjia3':'#icon-wenjianjia2'"></use>
                                    </svg>
                                    <svg data-v-7eb2bc79 aria-hidden="true" class="icon" v-else> 
                                        <use data-v-7eb2bc79  :xlink:href="node.expanded?'#icon-wenjianjia1':'#icon-iconset0196'"></use>
                                    </svg>
                                    <span>{{ node.label||'未命名群' }}</span>
                                </span>
                            </span>
                        </el-tree>
                    </el-main>
                </div>
            </el-col>
    
            <el-col :span="col_span" v-if="activeName=='second'"  style="border-left:1px solid #f2f2f2;">
                <el-main :style="'height:'+(innerHeight-220)+'px'" style="padding:0"
                    v-loading="loading_center"
                >
                    <p v-if="key_word&&list3.length==0&&!loading_center">暂无记录</p>
                    <div class="row-list" v-for="(item,index) in list3" :key="index"  @click="getContents(item)">
                        <div style="display:flex;">
                            <div>
                                <el-avatar size="medium" :src="item.avatar"></el-avatar>
                            </div>
                            <div  class="content">
                                <p>
                                    <label>{{item.from_user_name}}</label>
                                    <label style="margin-left:10;">来自</label>
                                    <span>{{item.mode=='C2C'?item.from_user_name+' 对 '+item.to_im_user_name+'发起私聊':item.group_name}}</span>
                                </p>
                                <div v-for="(one,indes) in item.msg_body" :key="indes">
                                    <div v-if="one.type=='TIMImageElem'">
                                        <el-image v-for="(img,index_ig) in one.list" :key="index_ig" class="img_content" :src="img.text" fit="scale-down" :preview-src-list="[img.text]" :z-index="9999"></el-image>
                                    </div>
                                    <div style="margin:10 0;display:flex;flex-wrap:wrap" v-else>
                                        <span v-for="(text,in_text) in one.list" :key="in_text">
                                            <span :style="'color:'+text.color" v-if="text.text!=' '">{{text.text}}</span>
                                            <span v-else style="margin-left:5;">  </span>
                                        </span>
                                    </div>
                                    
                                </div>
                                <label style="line-height:2;">{{item.add_time_str}}</label>
                            </div>
                        </div>
                        <el-button type="text" icon="el-icon-arrow-right" style="color:#AAAAAA;font-size:8px;margin-left:auto;"></el-button>
                        <span class="mark" style="color:#25B7AA;">查看上下文</span>
                    </div>
                </el-main>
            </el-col>

            <!-- 聊天记录 -->
            <el-col :span="col_span" v-show="chat_name" style="border-left:1px solid #f2f2f2;">
                <el-main :style="'height:'+(innerHeight-220)+'px'" style="padding:0" id="chatListRef" v-loading="contentLoading"
                    :infinite-scroll-disabled="contentLoading"     
                    infinite-scroll-distance="10"
                    v-infinite-scroll="nextContent"
                >
                    <div style="display:flex;line-height:2;">
                        <span style="font-size:#333333;font-weight:bold;">{{chat_name}} 聊天记录</span>
                    </div>
                    <div class="row-list" v-for="(item,index) in list_context" :key="index" style="align-items:unset;">
                        <div>
                            <el-avatar size="medium" :src="item.avatar"></el-avatar>
                        </div>
                        <div  class="content">
                            <label>{{item.from_user_name}}</label>
                            <div v-for="(one,indes) in item.msg_body" :key="indes" >
                                <div v-if="one.type=='TIMImageElem'">
                                    <el-image v-for="(img,index_ig) in one.list" :key="index_ig" class="img_content" :src="img.text" fit="scale-down" :preview-src-list="[img.text]" :z-index="9999"></el-image>
                                </div>
                                <div style="margin:10 0;display:flex;flex-wrap:wrap" v-else>
                                    <span v-for="(text,in_text) in one.list" :key="in_text">
                                        <span :style="'color:'+text.color" v-if="text.text!=' '">{{text.text}}</span>
                                        <span v-else style="margin-left:5;">  </span>
                                    </span>
                                </div>
                                
                            </div>
                            <div style="display:flex;justify-content:space-between;;">
                                <label>{{item.add_time_str}}</label>
                            </div>
                        </div>
                    </div>
                </el-main>
            </el-col>
        </el-row>
    </section>
</template>

<script>
import {group,word} from "@/api/school";
import {mapState } from "vuex";
import {filterByName} from "@/utils/filter"
import formatter from "@/mixins/formatter"
export default {
    mixins:[formatter],
    data () {
        return{
            key_word:null,
            activeName:'first',
            col_span:8,
         
            filter_word:null,
            group_name:'',
            list:[],  //敏感词命中列表
            list3:[],  //记录
            list_context:[],//上下文
            chat_name:'',
            group_tree:[],
            original_list:[],
            contentLoading:false,

            msg_list:[],
            cur_param:{msg_seq:0,},
            cur_mode:'Group',
            loading:false,
            loading_center:false,
        }
    },
    components:{},
    computed: {
        ...mapState("user", ['innerHeight']),
    },

    watch: {
        group_name(val) {
            this.$refs.tree.filter(val);
        },
    },

    methods:{
        nextContent(val){
            if(this.activeName=='first'){return}
            let len=this.list_context.length-1
            let cur=this.list_context[len]&&this.list_context[len].msg_seq?this.list_context[len].msg_seq+1:-1
            if(cur&&this.msg_list.findIndex(z=>z==cur)==-1){
                this.msg_list.push(cur)
                this.cur_param.msg_seq=cur
                this.cur_param.up=false
                this.getUpOrDownContents(this.cur_param,1)
            }
        },
        filterBy(condition,text){
            this.list=filterByName(this.original_list,condition,text)
        },
        toSearch(){
            this.$router.push({name:'searchImChart',query:{name:this.key_word}})
        },
        filterNode(value, data) {
            if (!value) return true;
            return data.name&&data.name.indexOf(value) !== -1;
        },


        handleNodeClick(data, Node) {
            if(!data.group_id&&data.category!='one'||data.category=='one'&&!data.from_im_user_id){
                return
            }
            this.chat_name=data.name||'未命名群'
            this.list3=[]
            this.list_context=[];
            
            if(data.category=='one'){
                this.cur_mode='one'
                this.getContents(data);
            }else{
                let param={
                    group_id:data.group_id
                }
                this.contentLoading=true
                group.searchForMsg(param).then(res=>{
                    this.contentLoading=false
                    if(res.data){
                        this.list_context=res.data.msg.map(r=>{
                            return{
                                mode:r.mode,
                                msg_seq:r.msg_seq,
                                group_id:r.group?r.group.group_id:null,
                                group_name:r.group?r.group.name||'未命名群':null,
                                avatar:r.from_user?r.from_user.avatar:'',
                                from_user_name:r.from_user?r.from_user.name:'',
                                from_im_user_id:r.from_user?r.from_user.im_user_id:null,
                                to_im_user_id:r.to_user?r.to_user.im_user_id:null,
                                to_im_user_name:r.to_user?r.to_user.name:null,
                                msg_body:this.markBadWord(r.msg_body),
                                add_time_str:this.timeForLimitTime(r.add_time)
                            }
                        })
                    }
                })
            }
        },

        markBadWord(msg_body){
            if(!msg_body||msg_body.legnth==0){
                return []
            }
            msg_body.forEach(z=>{
                z.list=[]
                if(z.type=='TIMTextElem'){
                    let text_split=z.text.trim().split('')
                    text_split.forEach((c,n)=>{
                        let color=''
                        if(z.index&&z.index.length>0){
                            for (let i = 0; i < z.index.length; i++){
                                if(n>=z.index[i].start&&n<=z.index[i].end){
                                    color='#FF4A00'
                                    break
                                }
                            }
                        }
                        z.list.push({text:c,color:color})
                    })
                }else{
                    z.list=[{text:z.text,color:''}]
                }
            })
            return msg_body
        },
        
        searByWord(row, column, event){
            this.chat_name=null;
            this.key_word=row.name
            let param={
                key_word:this.key_word
            }
            this.loading_center=true
            group.searchForMsg(param).then(res=>{
                this.loading_center=false
                if(res.data){
                    this.list3=res.data.msg.map(r=>{
                        return{
                            mode:r.mode,
                            msg_seq:r.msg_seq,
                            group_id:r.group?r.group.group_id:null,
                            group_name:r.group?r.group.name||'未命名群':null,
                            avatar:r.from_user?r.from_user.avatar:'',
                            from_user_name:r.from_user?r.from_user.name:'',
                            from_im_user_id:r.from_user?r.from_user.im_user_id:null,
                            to_im_user_id:r.to_user?r.to_user.im_user_id:null,
                            to_im_user_name:r.to_user?r.to_user.name:null,
                            msg_body:this.markBadWord(r.msg_body),
                            add_time_str:this.timeForLimitTime(r.add_time)
                        }
                    })
                }else{
                    this.list3=[]
                }
            })
        },

        getUpOrDownContents(param,val,pagesize){
            if(param.msg_seq==-1){
                return
            }
            if(pagesize){
                param.num=pagesize
            }
            param.is_admin=true
            this.contentLoading=true
            let  promise=this.cur_mode=='Group'?group.getGroupContext(param):group.getContext(param)
            promise.then(res=>{
                this.contentLoading=false
                if(res.data){
                    let items=res.data.map(r=>{
                        return{
                            mode:r.mode,
                            msg_seq:r.msg_seq,
                            group_id:r.group?r.group.group_id:null,
                            group_name:r.group?r.group.name||'未命名群':null,
                            avatar:r.from_user?r.from_user.avatar:'',
                            from_user_name:r.from_user?r.from_user.namecard||r.from_user.nickname||r.from_user.name:'',
                            from_im_user_id:r.from_user?r.from_user.im_user_id:null,
                            to_im_user_id:r.to_user?r.to_user.im_user_id:null,
                            msg_body:this.markBadWord(r.msg_body),
                            add_time_str:this.timeForLimitTime(r.add_time)
                        }
                    })
                    this.list_context=val==1?this.list_context.concat(items):val==2?items.concat(this.list_context):items

                    let dom1=document.getElementById('chatListRef')
                    dom1.onscroll = (_r) => {

                        if(dom1.scrollTop==0){
                            let cur=this.list_context[0]&&this.list_context[0].msg_seq?this.list_context[0].msg_seq-1:0
                            if(cur&&this.msg_list.findIndex(z=>z==cur)==-1){
                                this.msg_list.push(cur)
                                this.cur_param.msg_seq=cur
                                this.cur_param.up=true
                                this.getUpOrDownContents(this.cur_param,2,5)
                            }
                        }
                    }
                }
            })
        },
        getContents(item){
            this.chat_name=item.name||item.group_name;
            let param
            let promise
            this.list_context=[];
            this.is_context=true;
            this.cur_mode=item.mode
            if(this.cur_mode=='Group'){  //群
                param={
                    group_id:item.group_id,
                    msg_seq:item.msg_seq?item.msg_seq:1,
                    up:false
                }
            }else{  //私聊
                param={
                    user_id_1:item.from_im_user_id,
                    user_id_2:item.to_im_user_id,
                    msg_seq:item.msg_seq?item.msg_seq:1,
                    up:false
                }
            }
            this.msg_list=[item.msg_seq]
            this.cur_param=param
            this.getUpOrDownContents(param,2)
        },
        handleClick(val){
            this.col_span=this.activeName=='first'?10:8
            this.is_show_content=false
            this.list3=[]
            this.list_context=[]
            this.chat_name=null
            this.key_word=null
            this.getList();
        },
        getList(){
            let param={
                word:this.filter_word,
            }
            if(this.activeName!='second'){
                return
            }
            this.original_list=[]
            this.loading=true
            word.sumForWords(param).then(res=>{
                this.loading=false
                if(res.data){
                    this.list=res.data.map(r=>{
                        return{
                            name:r.word,
                            count:r.count||0
                        }
                    })
                    this.original_list=this.list
                }
            })
        },
    },
    mounted(){
        this.loading=true
        group.getGroup().then(res0=>{
            this.loading=false
            if(res0.data){
                this.group_tree=res0.data

                let arr={
                    name:'家园私聊',
                    category:'one',
                    children:[]
                }
                group.findC2C({my:false}).then(res=>{
                    if(res.data){
                        arr.children=res.data.map(r=>{
                            let name1=r.from_user?r.from_user.name||r.from_user.im_user_id:''
                            let name2=r.to_user?r.to_user.name||r.to_user.im_user_id:''
                            let text=(r.msg_body?r.msg_body.map(z=>{return z.type=='TIMImageElem'?'图片':z.text}).join(';'):text)
                            return{
                                category:'one',
                                name:name1+'对'+name2+'发起群聊',
                                from_im_user_id:r.from_user?r.from_user.im_user_id:null,
                                to_im_user_id:r.to_user?r.to_user.im_user_id:null,
                                text:text,
                                msg_seq:r.msg_seq
                            }
                        });
                    }
                })
                this.group_tree.push(arr)
            }
        })
    }
}
</script>

<style scoped lang="scss">
.el-tabs /deep/ .el-tabs__header{
    margin:0;
}
.el-col{
    padding-right:10px;
    padding-left: 10px;
    margin-top:20px;
    height: 70%;
}
.row-list{
    padding:10 0 15 0;
    display: flex;
    font-size: 14px;
    color:#333333;
    border-bottom: 1px solid #f2f2f2;
    align-items: center;
    position: relative;
    .el-avatar{
        margin-right: 8px;
    }
    .content{
        flex-grow: 1;
        line-height: 1.5;
        margin-right:5px;
        label{
            color: #999999;
        }
    }
    .mark{
        position: absolute;
        bottom:20;
        right: 10;
        display: none;
        cursor: pointer;
    }
}

.row-list:hover {
    background-color: rgba(37, 183, 170, 0.1);
    .mark{display: block}
}

.el-tree /deep/ .el-tree-node__content{
    padding: 20px;
    border:1px solid #EBEEF5;
    border-top:0.6px solid #EBEEF5;
    border-bottom:0.6px solid #EBEEF5;
}
.el-tree /deep/.custom-tree-node{
    width:100%;
    display: flex;
    white-space: pre-wrap;
}
.el-tree /deep/ .el-tree-node.is-current > .el-tree-node__content {
    background-color:rgba(37, 183, 170, 0.1) !important;
}
.img_content{
    max-width: 200px;
    height: auto;
    display: block;
    text-align: left;
}
.el-image{
    height: auto;
    margin-bottom: 10px;
}
.el-image /deep/ .el-image__inner{
    height: auto;
}

.el-image /deep/ .el-image__error{
    height: 170px;
}
</style>


// WEBPACK FOOTER //
// src/views/imChart/content.vue